<script setup>
const ALIAS = {
  green:'green', yellow:'yellow', orange:'orange', red:'red', delivered:'green', 'invoice generated':'green', ok:'green', healthy:'green', achieved:'green', warning:'yellow', minor:'yellow', delay:'orange', significant:'orange', critical:'red', breach:'red', oos:'red',
  // New order-lifecycle stage names (multi-item order model): in-progress
  // stages read as yellow (normal, not yet complete), Cancelled as red
  // (terminal, nothing further happens), Returned for Modification as
  // orange (needs the Sales Exec's attention before it can proceed).
  'order received':'yellow', 'telecaller validation':'yellow', 'stock allocation':'yellow',
  'warehouse processing':'yellow', 'dispatch pending':'yellow', 'dispatched':'yellow',
  'cancelled':'red', 'returned for modification':'orange',
}
const props = defineProps({ status: { type: String, required: true }, label: { type: String, default: null }, dotOnly: { type: Boolean, default: false } })
const tone = () => ALIAS[String(props.status).toLowerCase().trim()] || 'yellow'
const displayLabel = () => props.label !== null ? props.label : props.status
</script>

<template>
  <span class="status-pill" :class="tone()">
    <span class="dot"></span>
    <span v-if="!dotOnly">{{ displayLabel() }}</span>
  </span>
</template>
